import { FC } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { MapContainer, Marker as MarkerOSM, TileLayer } from 'react-leaflet';
import Leaflet from 'leaflet';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { mapSupplier, imgCenterPoint } from 'constants/generic';

interface DetailsMapProps {
  lat: number;
  lng: number;
  zoom?: number;
}
const DetailsMap: FC<DetailsMapProps> = ({ lat = 0, lng = 0, zoom = 14 }) => {

  const iconCenter = new Leaflet.Icon({
    iconUrl: imgCenterPoint,
    iconSize: [16, 28],
  });
  return (
    <div>
      {mapSupplier === 'google' && (
        <GoogleMap
          mapContainerClassName="map-wr"
          center={{ lat, lng }}
          zoom={zoom}
          options={{
            streetViewControl: false,
          }}
        >
          <Marker position={{ lat, lng }} />
        </GoogleMap>
      )}

      {mapSupplier === 'osm' && (
        <div className="map-wr">
          <MapContainer center={{ lat, lng }} zoom={zoom}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <MarkerOSM zIndexOffset={10} position={{ lat, lng }} icon={iconCenter} />
          </MapContainer>
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(DetailsMap, 'DetailsMap');
